import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const SVG = ({
  className = '',
  size = '24'
}) => ___EmotionJSX("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: size,
  height: size,
  className: className,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, ___EmotionJSX("polyline", {
  points: "16 16 12 12 8 16"
}), ___EmotionJSX("line", {
  x1: "12",
  y1: "12",
  x2: "12",
  y2: "21"
}), ___EmotionJSX("path", {
  d: "M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"
}), ___EmotionJSX("polyline", {
  points: "16 16 12 12 8 16"
}));
export default SVG;